import {showNotification} from 'platform/components';

import {useGetSkodaPlusPlatformQuery, useSkodaPlusAuthenticateMutation} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationForm,
  PlatformAuthenticationFormProps,
} from './PlatformAuthenticationForm';
import {PlatformPhotoSettings} from './PlatformPhotoSettings';

export function PlatformSettingsSkodaPlus() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetSkodaPlusPlatformQuery({params});
  const [saveAuthentication] = useSkodaPlusAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormProps['onSubmit'] = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <>
      <PlatformAuthenticationForm
        values={data?.credentials}
        isFetching={isFetching}
        isError={isError}
        onSubmit={onSubmitCredentials}
      />
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.SKODA_PLUS} />
    </>
  );
}
